var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22134 5.9533C7.30559 5.24948 6.71227 4.7381 6.15259 5.14358C4.44179 6.38301 2.35476 9.20253 2.03358 11.8856C1.73446 14.3843 3.46689 16.6587 5.90308 16.9656C8.33927 17.2724 10.5567 15.4954 10.8558 12.9966C11.1549 10.4978 9.42251 8.22343 6.98631 7.91662L7.22134 5.9533Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3319 5.9533C18.4162 5.24948 17.8229 4.7381 17.2632 5.14358C15.5524 6.38301 13.4654 9.20253 13.1442 11.8856C12.8451 14.3843 14.5775 16.6587 17.0137 16.9656C19.4499 17.2724 21.6673 15.4954 21.9664 12.9966C22.2655 10.4978 20.5331 8.22343 18.0969 7.91662L18.3319 5.9533Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.62052d5e878dce03e1eb299a818e6774.svg";
export { ForwardRef as ReactComponent };